import { createApp } from 'vue'
import MainApp from '../../../components/01-global_components/Apps/MainApp.vue';
import SharedApp from '../../../components/01-global_components/Apps/SharedApp.vue';

//Plugins
import VueLoading from 'vue-loading-overlay';
import MasonryWall from '@yeger/vue-masonry-wall';
import { VueDraggable } from 'vue-draggable-plus';

let element = document.querySelector("#app");

if (element) {
  let props = decodeBase64(element.dataset.context);

  const app = createApp(MainApp, props);

  app.component('vloading', VueLoading);

  app.use(require("vue-cookies"));

  app.directive("focus", {
    inserted: function (el) {
      el.focus();
    },
  });

  app.mount('#app');
}



/**
 * Dynamic component dispenser
 * that should have access to sharedData
 *
 */
const vueRootElements = document.querySelectorAll('[data-component]');
if (vueRootElements.length > 0) {
  vueRootElements.forEach(element => {
    let dataObject = {};
    for (let dataAttr in element.dataset) {
      if (dataAttr == "component")
        continue;
      else if (dataAttr == "context") {
        let contextData = decodeBase64(element.dataset[dataAttr]);

        for (let prop in contextData) {
          dataObject[prop] = contextData[prop];
        }
        continue;
      }

      dataObject[dataAttr] = element.dataset[dataAttr];
    }
    const app2 = createApp(SharedApp, { component: element.dataset.component, componentProps: dataObject });

    app2.component('vloading', VueLoading);
    app2.component('VueDraggable', VueDraggable);
    app2.use(MasonryWall);
    app2.mount(element);
  });
}


function decodeBase64(base64Data) {
  if (base64Data) {
    let binaryString = atob(base64Data);
    let encodedText = Uint8Array.from(binaryString, (m) => m.codePointAt(0));
    return JSON.parse(new TextDecoder().decode(encodedText));
  }
  return {};
}